import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { SsoUserDetailsDto } from '../../interfaces/sso-user-details-dto';
import { envToken } from '../../tokens/env-token';

@Injectable({
    providedIn: 'root'
})
export class IdpUnlinkService {
    private http = inject(HttpClient);
    private env = inject(envToken);


    private baseUrl = '';

    constructor() {
        this.baseUrl = this.env.apiUrl + '/api/v1/idp-unlink';
    }

    unlink(ssoUserDetails: SsoUserDetailsDto): Observable<SsoUserDetailsDto> {
        return this.http.post<SsoUserDetailsDto>(this.baseUrl, ssoUserDetails);
    }
}
